import React from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Section from "./Section";
import SectionHeader from "./SectionHeader";

const useStyles = makeStyles((theme) => ({
  itemsContainer: {
    marginTop: 60
  },
  row: {
    // Reverse every other row
    "&:nth-of-type(even)": {
      flexDirection: "row-reverse",
    },

    // Spacing between rows
    "&:not(:last-child)": {
      marginBottom: `${theme.spacing(3)}px`,
    },
  },
  figure: {
    textAlign: 'center',
    maxWidth: 1000,
    margin: "20px auto",
  },
  image: {
    maxHeight: 450,
    maxWidth: "100%",
  },
}));

function FeaturesSection(props) {
  const classes = useStyles();

  // Choose base URL dynamically
  const origin = window.location.origin;
  const isLocalhost = origin.includes("localhost");
  const baseUrl = isLocalhost ? "https://dev-www.shownav.net" : origin;


  const screenshotAdmin = `${baseUrl}/web-screenshot.png`;
  const screenshotMobile = `${baseUrl}/mobile-screenshot.png`;
  const screenshotMap = `${baseUrl}/map-screenshot.png`;

  const items = [
    {
      title: "ORGANIZATION",
      description:
        "Generate dynamic location directories for seamless crew navigation through the showNAV mobile app.",
      image: screenshotAdmin,
    },
    {
      title: "NAVIGATION",
      description: "Crew can select any location to navigate directly via Google Maps. showNAV utilizes precise GPS coordinates, ensuring greater accuracy than traditional addresses.",
      image: screenshotMobile,
    }
  ];

  return (
    <Section
      bgColor={props.bgColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container>
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={4}
          textAlign="center"
        />
        <Container
          maxWidth="lg"
          disableGutters={true}
          className={classes.itemsContainer}
          style={{ whiteSpace: 'pre-line' }}
        >
          {items.map((item, index) => (
            <Grid
              className={classes.row}
              container={true}
              item={true}
              alignItems="center"
              spacing={4}
              key={index}
            >
              <Grid item={true} xs={12} md={6}>
                <Box
                  textAlign={{
                    xs: "center",
                    md: "left",
                  }}
                >
                  <Typography variant="h5" gutterBottom={true}>
                  <span style={{color: '#ffd600ff', fontWeight: 'bold'}}>{item.title}</span>
                  </Typography>
                  <Typography variant="subtitle1">
                    {item.description}
                  </Typography>
                </Box>
              </Grid>
              <Grid item={true} xs={12} md={6}>
                <figure className={classes.figure}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className={classes.image}
                  />
                </figure>
              </Grid>
            </Grid>
          ))}
        </Container>
        <Grid
              className={classes.row}
              container={true}
              item={true}
              alignItems="center"
              spacing={4}
            >
        <Grid item={true} xs={12} md={4}>
                <Box
                  textAlign={{
                    xs: "center",
                    md: "left",
                  }}
                >
                  <Typography variant="h5" gutterBottom={true}>
                  <span style={{color: '#ffd600ff', fontWeight: 'bold'}}>AUTOMATION</span>
                  </Typography>
                  <Typography variant="subtitle1">
                  showNAV automatically generates location maps, saving your production time and resources while delivering industry-standard design for your crew.
                  </Typography>
                </Box>
              </Grid>
              <Grid item={true} xs={12} md={8}>
                <figure className={classes.figure}>
                  <img
                    src={screenshotMap}
                    alt="screenshot of automated map generation"
                    style={{maxHeight: 'auto', maxWidth: "100%",}}
                  />
                </figure>
              </Grid>
              </Grid>

      </Container>
    </Section>
  );
}

export default FeaturesSection;
